export enum OfferNavLinkType {
  Overview = "overview",
  Contract = "contract",
  ServiceProgram = "service-program",
  Pests = "pests",
  Calculation = "calculation",
  Addresses = "addresses",
  Representative = "representative",
  CoverLetter = "coverletter",
  TextBlocks = "textblocks",
  AdditionalInfo = "additional-info",
}
export enum ConfigOrigin {
  Derived = "derived",
  Manual = "manual",
  Migrated = "migrated",
}

export enum OfferType {
  Main = "main",
  Extension = "extension",
}

export enum MainOfferKind {
  Unspecified = "unspecified",
  FirstOffer = "first_offer",
  NewContract = "new_contract",
}

export enum PriorIoTPresenceState {
  Unknown = "unknown",
  Absent = "absent",
  Present = "present",
}

export enum SectionMode {
  Omit = "omit",
  Include = "include",
}

export enum IoTTableMode {
  Exclude = "exclude",
  Include = "include",
}

export enum ExtensionAreaScope {
  Indoor = "indoor",
  Outdoor = "outdoor",
  IndoorOutdoor = "indoor_outdoor",
}

export enum TemplateScenario {
  MainLegacy = "main_legacy",
  MainFirstOffer = "main_first_offer",
  MainNewContract = "main_new_contract",
  ExtensionTableOnly = "extension_table_only",
  ExtensionIotOnly = "extension_iot_only",
  ExtensionTableAndIot = "extension_table_and_iot",
}

export enum ChangeMode {
  Manual = "manual",
  Automatic = "automatic",
}

export enum ContractStartMode {
  WithInstallation = "with_installation",
  OnDate = "on_date",
}

export enum ContractTermMode {
  Unlimited = "unlimited",
  TwoPlusOne = "two_plus_one",
  ThreePlusOne = "three_plus_one",
  ByMainContract = "by_main_contract",
  ByFrameworkContract = "by_framework_contract",
  Custom = "custom",
}

export enum IoTAdditionalTrapRentMode {
  General = "general",
  PerMonitor = "per_monitor",
}
